import { sortStrings } from "_helpers";

import dayjs from 'dayjs';

const dateRender = (date) => {
    if( !date || date === '0000-00-00' || date === '0000-00-00 00:00:00' ) return '';
    const d = dayjs(date);
    return d.isValid() ? d.format('DD/MM/YYYY') : '';
};

const titleRender = ( title, align = 'center' ) => {
    let classNameExtend = "";
    switch( align ){
        case 'left' : classNameExtend = 'justify-content-start text-start'; break ;
        case 'center' : classNameExtend = 'justify-content-center text-center'; break ;
        case 'right' : classNameExtend = 'justify-content-end text-end'; break ;
        default : break ;
    }

    return <div className={["d-flex", classNameExtend].join(" ")}>{ title }</div>;
}

export const columns = [
    {
        title: "Nom",
        dataIndex: "name",
        width: "35%",
        sorter: (a, b) => sortStrings(a.name, b.name)
    },{
        title: "E-mail",
        dataIndex: "email",
        width: "35%",
        sorter: (a, b) => sortStrings(a.email, b.email)
    },{
        title: "Activée le",
        dataIndex: "date_activation",
        width: "15%",
        render: dateRender
    },{
        title: "Désactivée le",
        dataIndex: "date_deactivation",
        width: "15%",
        render: dateRender
    }
].map(el => {
    return {
        ...el,
        title: titleRender(el.title),
        align: 'center'
    }
});